import { createIcon } from '@consta/icons/Icon'
import type { FC, SVGProps } from 'react'

const IconPlotsM: FC<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.27227e-05 7.52499C4.27227e-05 7.13839 0.313441 6.82499 0.700037 6.82499C1.08663 6.82499 1.40003 7.13839 1.40003 7.52499V13.1249C1.40003 13.5115 1.08663 13.8249 0.700037 13.8249C0.313441 13.8249 4.27227e-05 13.5115 4.27227e-05 13.1249V7.52499Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.48 0.315061C4.76722 0.0996489 5.17084 0.136455 5.41436 0.400264L9.20895 4.51107L12.9116 2.04261C13.2333 1.82817 13.6679 1.91509 13.8824 2.23675C14.0968 2.55842 14.0099 2.99303 13.6882 3.20747L9.48825 6.00745C9.20183 6.19839 8.81909 6.15275 8.58561 5.89981L4.81435 1.81428L1.12003 4.58503C0.810755 4.81698 0.371998 4.7543 0.14004 4.44503C-0.0919177 4.13575 -0.029238 3.69699 0.280039 3.46503L4.48 0.315061Z"
    />
    <path d="M4.20001 6.125C4.20001 5.7384 4.51341 5.425 4.9 5.425C5.2866 5.425 5.6 5.7384 5.6 6.125V13.1249C5.6 13.5115 5.2866 13.8249 4.9 13.8249C4.51341 13.8249 4.20001 13.5115 4.20001 13.1249V6.125Z" />
    <path d="M12.5999 7.52499C12.5999 7.13839 12.9133 6.82499 13.2999 6.82499C13.6865 6.82499 13.9999 7.13839 13.9999 7.52499V13.1249C13.9999 13.5115 13.6865 13.8249 13.2999 13.8249C12.9133 13.8249 12.5999 13.5115 12.5999 13.1249V7.52499Z" />
    <path d="M8.39997 9.62497C8.39997 9.23837 8.71337 8.92498 9.09997 8.92498C9.48656 8.92498 9.79996 9.23837 9.79996 9.62497V13.1249C9.79996 13.5115 9.48656 13.8249 9.09997 13.8249C8.71337 13.8249 8.39997 13.5115 8.39997 13.1249V9.62497Z" />
  </svg>
)

export const IconPlots = createIcon({
  name: 'IconPlots',
  l: IconPlotsM,
  m: IconPlotsM,
  s: IconPlotsM,
  xs: IconPlotsM,
})
